import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const VerifyMov = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/administracion-inventario/verificar/movimientos/etiquetas`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        verifyMovMutation: mutation.mutate,
    };
}